// extracted by css-extract-rspack-plugin
export default {"spinnerContainer":"_f2d631b1"};